import {useMemo} from 'react';
import {useLinkedinChannels} from './useDataSource';

export default function useGetAllLinkedInChannelIds() {
    const linkedinChannels = useLinkedinChannels();
    return useMemo(() => {
        return linkedinChannels.data?.map((d) => d.id);
    }, [linkedinChannels]);
}
